import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./AddBreakdown.css";

const AddDriver = () => {
  const [formData, setFormData] = useState({
    reporting_driver_code: "",
    driver_name: "",
    is_active: "Y",
  });
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  // normalize: keys to lowercase, treat "NULL"/"null" as null
  const normalizeVal = (v) => {
    if (v === undefined || v === null) return null;
    if (typeof v === "string") {
      const t = v.trim();
      if (t === "" || t.toLowerCase() === "null") return null;
      return t;
    }
    return v;
  };

  useEffect(() => {
    if (id) {
      fetchDriverDetails(id);
      setIsEditing(true);
    }
  }, [id]);

  const fetchDriverDetails = async (driverId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/drivers/${driverId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const rec = response.data || {};
      // normalize: keys to lowercase
      const normalized = {};
      Object.keys(rec).forEach((k) => {
        normalized[k.toLowerCase()] = normalizeVal(rec[k]);
      });

      setFormData({
        reporting_driver_code: normalized.reporting_driver_code || "",
        driver_name: normalized.driver_name || "",
        is_active: normalized.is_active || "Y",
      });
    } catch (error) {
      console.error("Error fetching driver details:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      if (isEditing) {
        await axios.patch(
          `${process.env.REACT_APP_BASE_API_URL}/drivers/${id}`,
          formData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        navigate("/driver-management");
      } else {
        await axios.post(
          `${process.env.REACT_APP_BASE_API_URL}/drivers`,
          formData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        navigate("/driver-management");
      }
    } catch (error) {
      console.error("Error adding driver:", error);
    }
  };

  return (
    <div className="container-add-breakdown">
      <button
        className="close-button"
        onClick={() => navigate("/driver-management")}
      >
        ×
      </button>
      <form onSubmit={handleSubmit} className="form-grid-breakdown">
        <div>
          <label className="form-label-breakdown">
            Driver Code <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-input-breakdown"
            name="reporting_driver_code"
            value={formData.reporting_driver_code}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label className="form-label-breakdown">
            Driver Name <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-input-breakdown"
            name="driver_name"
            value={formData.driver_name}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label className="form-label-breakdown">
            Status <span className="required">*</span>
          </label>
          <select
            className="form-input-breakdown form-select-breakdown"
            name="is_active"
            value={formData.is_active}
            onChange={handleChange}
            required
          >
            <option value="Y">Active</option>
            <option value="N">Inactive</option>
          </select>
        </div>

        <button type="submit" className="submit-button-breakdown1">
          {isEditing ? "Update" : "Save"}
        </button>
      </form>
    </div>
  );
};

export default AddDriver;
